import type { GetStaticProps } from "next";

import { getPrivateLocation } from "~/api/location/getPrivateLocation";
import { getTags } from "~/api/tags/getTags";
import { getVenuesContactInfo } from "~/api/venues/getVenuesContactInfo";
import Spacer from "~/components/common/spacer";
import PrivateEventsButtons from "~/components/privateEvents/buttons";
import PrivateEventsDisplay from "~/components/privateEvents/display";
import PrivateEventsIntro from "~/components/privateEvents/intro";
import SEO from "~/components/SEO";
import AboutContact from "~/components/ui/contact";
import { PrivateLocationType } from "~/types/location/location.types";
import { LocationEnum } from "~/types/location/locationEnums.types";
import { FilterTagsEnum, TagType } from "~/types/tag/tag.types";
import { VenueContactInfo } from "~/types/venue/venue.types";
import { createVenuesContactInfoObject } from "~/utils/functions/locations.functions";

interface Props {
  tags: TagType[];
  privateLocations: PrivateLocationType[];
  contactInfo: Record<LocationEnum, VenueContactInfo>;
}

export const getStaticProps: GetStaticProps<Props, never> = async () => {
  const tags = await getTags(FilterTagsEnum.PRIVATE_LOCATIONS);
  const privateLocations = await getPrivateLocation();
  const venuesContactInfo = await getVenuesContactInfo();
  const contactInfo = createVenuesContactInfoObject(venuesContactInfo, [
    LocationEnum.HORS_LES_MURS,
  ]);

  return {
    props: { tags, privateLocations, contactInfo },
  };
};

const PrivateEvents = ({ tags, privateLocations, contactInfo }: Props) => {
  return (
    <>
      <SEO
        title="Silencio - Événements privés"
        description="Nos lieux uniques sont à votre disposition pour vos événements privés."
        nofollow={false}
        noindex={false}
      />
      <Spacer width={"100%"} height={"150px"} />
      <PrivateEventsIntro />
      <PrivateEventsDisplay privateLocations={privateLocations} tags={tags} />
      <PrivateEventsButtons />
      <AboutContact contactInfo={contactInfo} />
    </>
  );
};

export default PrivateEvents;
